var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174.695,
    height: 123.922,
    viewBox: "0 0 174.695 123.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a4b6c3;font-size:10px;font-family:SFProDisplay-Bold, SF Pro Display;font-weight:700;}.b{fill:#e6e6e6;}.c{fill:#fff;}.d{fill:#0f4b73;}.e{fill:#3f3d56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-902.275 -1874.82)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(987 1994)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.235,
    y: 0
  }, "$")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(902.275 1874.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M385.423,156.307a1.478,1.478,0,0,0-1.477,1.477V208.15a1.478,1.478,0,0,0,1.477,1.477H557.165a1.479,1.479,0,0,0,1.477-1.477V157.784a1.478,1.478,0,0,0-1.477-1.477Z",
    transform: "translate(-383.947 -156.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M394.692,212.971H561.985V167.052H394.692Z",
    transform: "translate(-390.991 -163.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M814.475,272.722a2.446,2.446,0,1,0,0,4.892h9.785a2.446,2.446,0,1,0,0-4.892Z",
    transform: "translate(-664.598 -232.629)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 112.951,
    height: 0.644,
    transform: "translate(49.157 35.349)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 14.248,
    cy: 14.248,
    rx: 14.248,
    ry: 14.248,
    transform: "translate(11.299 12.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M413.9,90.483l-.357-.536,11.737-7.825,8.049,3.863,11.577-7.4.156.066,22.873,9.757L486.27,79.4l17.808,7.22,22.377-19.82.427.482L504.207,87.371,486.3,80.11,467.95,89.121l-22.988-9.806L433.37,86.722l-8.041-3.86Z",
    transform: "translate(-364.56 -58.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M528.771,273.7a2.092,2.092,0,0,0,0,4.183h21.882a2.092,2.092,0,0,0,0-4.183Z",
    transform: "translate(-477.522 -233.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M450.43,215.9c.266-1.783-1.091-2.741-2.947-3.381l.6-2.415-1.471-.366-.586,2.352c-.386-.1-.783-.187-1.177-.277l.59-2.367-1.469-.366-.6,2.414c-.32-.073-.634-.145-.939-.221l0-.008-2.027-.506-.391,1.57s1.091.25,1.068.265a.782.782,0,0,1,.685.855l-.686,2.751a1.221,1.221,0,0,1,.153.049l-.155-.039-.962,3.854a.535.535,0,0,1-.674.349c.015.021-1.069-.267-1.069-.267l-.73,1.683,1.914.477c.356.089.7.183,1.048.27L440,225.025l1.468.366.6-2.417c.4.109.79.209,1.171.3l-.6,2.406,1.47.366.608-2.438c2.507.474,4.392.283,5.185-1.984a2.58,2.58,0,0,0-1.35-3.566,2.346,2.346,0,0,0,1.877-2.159Zm-3.359,4.71c-.455,1.826-3.528.839-4.525.591l.807-3.236c1,.249,4.192.741,3.718,2.645Zm.454-4.737c-.415,1.661-2.973.817-3.8.61l.732-2.935C445.284,213.759,447.957,214.145,447.525,215.877Z",
    transform: "translate(-419.151 -190.906)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(902.275 1945.422)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1010.662,506.94a2.446,2.446,0,0,0,0,4.892h9.785a2.446,2.446,0,1,0,0-4.892h-9.785Z",
    transform: "translate(-860.784 -466.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M581.61,390.524A1.478,1.478,0,0,0,580.133,392v50.367a1.478,1.478,0,0,0,1.477,1.477H753.351a1.478,1.478,0,0,0,1.477-1.477V392a1.479,1.479,0,0,0-1.477-1.477Z",
    transform: "translate(-580.133 -390.524)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M590.878,447.188H758.172V401.27H590.878Z",
    transform: "translate(-587.178 -397.569)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 112.951,
    height: 0.644,
    transform: "translate(49.157 35.349)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 14.248,
    cy: 14.248,
    rx: 14.248,
    ry: 14.248,
    transform: "translate(11.299 12.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M610.082,324.7l-.357-.536,11.737-7.825,8.049,3.863,11.577-7.4.157.066,22.873,9.757,18.34-9.009,17.808,7.219,22.377-19.819.427.482-22.675,20.084-17.911-7.261-18.346,9.012-22.988-9.806-11.593,7.406-8.041-3.86Z",
    transform: "translate(-560.746 -292.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M724.958,507.917a2.092,2.092,0,1,0,0,4.183H746.84a2.092,2.092,0,1,0,0-4.183Z",
    transform: "translate(-673.709 -467.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M530.711,366.785l5.768-8.123-5.768,3.405h0l-5.764-3.405,5.764,8.123h0Z",
    transform: "translate(-505.166 -330.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M530.711,340.688h0l5.764-3.407-5.764-9.564h0l-5.764,9.564Z",
    transform: "translate(-505.166 -310.447)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M814.475,272.722a2.446,2.446,0,1,0,0,4.892h9.785a2.446,2.446,0,1,0,0-4.892Z",
    transform: "translate(-664.598 -232.973)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6);
export default __webpack_public_path__ + "static/media/feature6.90bcbfd3182cc4517d9ee34fef3e07b9.svg";
export { ForwardRef as ReactComponent };